import { render } from "./VODListModal.vue?vue&type=template&id=3741d540"
import script from "./VODListModal.vue?vue&type=script&lang=js"
export * from "./VODListModal.vue?vue&type=script&lang=js"

import "./VODListModal.vue?vue&type=style&index=0&id=3741d540&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__